<!-- 由 woniu6162 创建于 2019-08-21 星期三 -->
<template>
  <div class="wegymer-dietician">
    <AppBar title="食物档案" :placeholder="true" :zIndex="10"> </AppBar>
    <div class="search-container">
      <van-field
        v-model="value"
        placeholder="想什么，就搜什么"
        @focus="$router.push('/calorie-query/search')"
      >
      </van-field>
      <span class="search-icon iconfont icon-sousuo"></span>
    </div>
    <!-- 超级食物 -->
    <div class="super-food-container" v-if="superFoodData.length">
      <div class="top">
        <div class="top-left">
          <div class="desc">健康吃 健康瘦</div>
          <div class="title">超级食物</div>
        </div>
        <div class="top-right">SUPER FOOD</div>
      </div>
      <div class="super-food-box">
        <div
          class="super-food-scroll"
          ref="scroll"
          @touchstart.stop="bindTouchStart"
          @touchmove.stop="bindTouchMove"
          @touchend.stop="bindTouchEnd"
        >
          <div
            class="scroll-content"
            ref="content"
            :style="{ left: left + 'px' }"
          >
            <div
              class="super-food-line"
              v-for="(item, index) in superFoodData"
              :class="{ 'super-food-line-offset': index === 1 }"
              :key="index"
            >
              <div
                class="super-food-list"
                :class="{ 'search-food-animate': scrollContainerNum == 2 }"
                :style="{ animationDuration: animationTime[index] }"
              >
                <div
                  class="super-food-item"
                  @click="toSuperFood(item2.id)"
                  :style="{ backgroundColor: item2.s_color }"
                  v-for="(item2, index2) in item"
                  :key="index2"
                >
                  <img
                    class="item-image"
                    v-if="item2.thumb_image_url"
                    :src="item2.thumb_image_url"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title_wrap">
      <span class="title-dot"></span>
      <span class="t_w_title">食物分类</span>
    </div>
    <!-- <van-row gutter="10" class="f_k_box">
      <template v-for="(item, index) in this.foodKinds">
        <van-col :key="index" span="8" class="f_k_wrap">
          <img :src="item.image" @click="toClass(item)" />
          <div>{{ item.name }}</div>
        </van-col>
      </template>
    </van-row> -->
    <div class="menu-list">
      <div
        class="menu-item"
        v-for="(item, index) in this.foodKinds"
        :key="index"
        @click="toClass(item)"
      >
        <div class="item-left">
          <div class="name">{{ item.name }}</div>
          <div class="short-name">{{ item.en_name }}</div>
        </div>
        <img class="item-mage" :src="item.image" alt="" />
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import AppBar from '@/components/app/nav-bar/index.vue'
export default {
  name: 'calorie-query-index',
  mixins: [],
  components: { AppBar },
  props: {},
  data() {
    return {
      left: 0,
      direction: 0,
      disabledMove: false,
      loaded: false,
      value: '',
      foodKinds: [],
      superFoodData: [],
      animationTime: [], //超级食物每行执行动画的时间
      autoScroll: {
        step: 0.5, //速度  每帧移动0.5px
        width: 0, // 可以滚动的宽度
        left: 0, //当前的位移
        disabledMove: false, // 是否禁用滚动
        direction: 0, //滚动方向
        touchX: 0,
        touchStartX: 0
      }
    }
  },

  computed: {
    //计算超级食物滚动区域是否需要多生成一个盒子保证滚动效果
    scrollContainerNum() {
      let num =
        this.superFoodData.length >= 1 && this.superFoodData[0].length >= 5
          ? 2
          : 1
      return num
    }
  },

  watch: {},

  created() {},

  mounted() {
    this.getDataOne()
    this.getSuperFoodList()
    //埋点 食物档案首页曝光
    this.$buryPoint('BG_SWDA', {})
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {})
  },

  destroyed() {},

  methods: {
    bindTouchStart(e) {
      this.disabledMove = true
      let touches = e.touches
      if (touches.length == 1) {
        let touch = touches[0]
        this.autoScroll.touchStartX = touch.screenX
        this.autoScroll.touchX = touch.screenX
      }
    },
    bindTouchMove(e) {
      let touches = e.touches
      if (touches.length == 1) {
        let touch = touches[0]
        let touchX = touch.screenX
        let direction = touchX - this.autoScroll.touchX
        this.autoScroll.touchX = touchX
        if (direction >= 0) {
          //列表向右移动
          let left = this.left + direction
          if (left < 0) {
            this.left =
              left < -this.autoScroll.width ? -this.autoScroll.width : left
          } else {
            this.left = 0
          }
        } else {
          let left = this.left + direction
          if (left < 0) {
            this.left =
              left < -this.autoScroll.width ? -this.autoScroll.width : left
          } else {
            this.left = 0
          }
        }
      }
    },
    bindTouchEnd() {
      this.direction =
        this.autoScroll.touchX > this.autoScroll.touchStartX ? 1 : 0
      setTimeout(() => {
        this.disabledMove = false
      }, 500)
    },
    initScroll() {
      let width = this.autoScroll.width
      if (!this.disabledMove) {
        if (this.direction) {
          if (this.left < 0) {
            this.left = this.left + this.autoScroll.step
          } else {
            this.direction = 0
          }
        } else {
          if (Math.abs(this.left) < width) {
            this.left = this.left - this.autoScroll.step
          } else {
            this.direction = 1
          }
        }
      }
      requestAnimationFrame(this.initScroll)
    },
    toSuperFood(id) {
      console.log(id)
      this.$router.push({
        path: '/calorie-query/super-food-detail',
        query: {
          id
        }
      })
    },
    // 食物分类
    getDataOne() {
      this.$http.getApp('member/Foods/foodClassifierList', {}).then(
        (rs) => {
          if (rs.data.code === 200) {
            this.foodKinds = rs.data.data
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
          this.loaded = true
        },
        (err) => {
          this.loaded = true
        }
      )
    },
    // 获取超级食物列表
    getSuperFoodList() {
      this.$http.getApp('member/Foods/foodSuperList', {}).then(
        (rs) => {
          if (rs.data.code === 200) {
            this.superFoodData = this.filterSuperFood(rs.data.data)
            this.animationTime = this.superFoodData.map((item) => {
              return item.length * 9 + 's'
            })
            this.$nextTick(() => {
              this.autoScroll.width =
                this.$refs.content.clientWidth - this.$refs.scroll.clientWidth
              this.initScroll()
            })
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
        },
        (err) => {}
      )
    },
    // 选择食物种类
    toClass(val) {
      console.log(val, 'val')
      this.$router.push({
        name: 'calorie-query-class-list',
        query: { classid: val.id, name: val.name }
      })
    },
    getRandomNum(length, num) {
      let arr = []
      let res = []
      for (let i = 0; i < length; i++) {
        arr.push(i)
      }
      for (let i = 0; i < num; i++) {
        let index = Math.floor(Math.random() * arr.length)
        res.push(arr[index])
        arr.splice(index, 1)
      }
      return res
    },
    filterSuperFood(data) {
      if (!Array.isArray(data)) {
        return []
      }
      let res = []
      let len = data.length
      if (len < 10) {
        //如果超级食物小于10个则放置在一行
        res.push(data)
      } else if (len >= 10 && len < 15) {
        //在10到14个之间则均匀放置两行
        let mid = Math.ceil(len / 2)
        let line1 = data.slice(0, mid)
        let line2 = data.slice(mid)
        res.push(line1)
        res.push(line2)
      } else {
        //大于等于15时均匀放置三行
        let mo = len % 3
        let mid = Math.ceil(len / 3)
        if (mo == 0) {
          let res = this.getRandomNum(data.length, 1)
          res.map((item) => {
            data.push(data[item])
          })
        } else if (mo == 2) {
          let res = this.getRandomNum(data.length, 2)
          res.map((item) => {
            data.push(data[item])
          })
        }
        console.log('长度', data.length)
        mid = Math.floor(data.length / 3)
        let line1 = data.slice(0, mid)
        let line2 = data.slice(mid, 2 * mid + 1)
        let line3 = data.splice(2 * mid + 1)
        console.log(line1, line2, line3)
        res.push(line1)
        res.push(line2)
        res.push(line3)
      }
      return res
    }
  }
}
</script>

<style lang="scss">
.wegymer-dietician {
  .van-field {
    background: transparent;
    padding: 0px;
  }

  .van-field {
    display: flex;
    align-items: center;
    position: relative;
    height: 14vw;
    box-sizing: border-box;

    svg {
      width: 4.3vw;
      height: 4.3vw;
      position: absolute;
      z-index: 200;
      left: 7vw;
      top: 4.8vw;
      fill: #6236ff;
    }

    input {
      height: 34px;
      background: #ffffff;
      box-shadow: 0px 3px 9px 0px rgba(160, 120, 251, 0.07);
      border-radius: 17px;
      padding: 6px 18px 6px 48px;
    }

    // input {
    //   background: #f5f5f5;
    //   border-radius: 1.1vw;
    //   padding: 1.8vw 2.7vw;
    // }
  }
}
</style>
<style lang="scss" scoped>
.wegymer-dietician {
  padding: 13px 20px;
  box-sizing: border-box;
  min-height: 100vh;
  background: #f9f9f9;

  .search-container {
    position: relative;
    width: 100%;
    margin-bottom: 28px;

    .search-icon {
      position: absolute;
      left: 18px;
      top: 50%;
      font-size: 18px;
      color: #6236ff;
      font-weight: 600;
      transform: translate(0%, -50%);
    }
  }

  .title_wrap {
    margin-bottom: 12px;
    display: flex;
    align-items: center;

    .title-dot {
      display: inline-block;
      margin-right: 18px;
      width: 6px;
      height: 15px;
      background: linear-gradient(
        180deg,
        rgba(98, 54, 255, 0.3) 0%,
        #6236ff 100%
      );
      transform: rotate(30deg);
      border-radius: 3px;
    }

    .t_w_title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }
  }

  .super-food-container {
    overflow: hidden;
    margin-bottom: 24px;
    background: #ffffff;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    padding: 22px 0px 19px;

    .top {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 20px;
      display: flex;

      .top-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
      }

      .top-right {
        font-size: 10px;
        color: rgba(0, 0, 0, 0.16);
        font-style: italic;
        font-weight: 600;
      }
    }

    .title {
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
      font-weight: 600;
      color: #000000;
      line-height: 33px;
      margin-bottom: 14px;
    }

    .desc {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 14px;
      letter-spacing: 4px;
    }

    .super-food-box {
      .search-food-animate {
        // animation: myScroll 60s linear infinite;
      }

      .super-food-scroll {
        width: 100%;

        .scroll-content {
          position: relative;
          left: 0;
          display: inline-block;
          // animation: myScroll 30s linear infinite;
        }

        .super-food-line {
          width: auto;
          display: inline-flex;

          .super-food-list {
            margin: 4px 0px;
            display: inline-flex;
            align-items: center;
            flex-wrap: nowrap;

            .super-food-item {
              flex-shrink: 0;
              width: 72px;
              height: 72px;
              background: #f1f9ed;
              border-radius: 12px;
              overflow: hidden;
              margin-right: 8px;

              .item-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .super-food-item:last-child {
              margin-right: 0;
            }
          }
        }

        .super-food-line-offset {
          width: 100%;
          height: 80px;
          position: relative;
          overflow: hidden;

          // margin-left: -41px;
          .super-food-list {
            position: absolute;
            left: 0px;
            top: 0;
            transform: translate(-41px, 0px);
          }
        }
      }
    }
  }

  .menu-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .menu-item {
      width: 162px;
      background: #ffffff;
      border-radius: 12px;
      overflow: hidden;
      display: inline-flex;
      align-items: center;
      padding: 9px 14px;
      box-sizing: border-box;
      margin: 5px 11px 5px 0px;

      .item-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .name {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 2px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .short-name {
          font-size: 10px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.3);
          line-height: 11px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .item-mage {
        width: 44px;
        height: 44px;
      }
    }

    .menu-item:nth-child(2n) {
      margin-right: 0px;
    }
  }
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

@keyframes myScroll {
  0% {
    transform: translate(0%, 0%);
  }

  50% {
    transform: translate(-100%, 0%);
  }

  100% {
    transform: translate(0%, 0%);
  }
}
</style>
